export const authorizeStyles = (width) => {
    if (width <= 768) {
        return {
            container: {
                width: "100vw",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                boxSizing: "border-box",
                minHeight: "100vh",
            },
            form: {
                maxWidth: "100%",
                backgroundColor: "#F3F3FF",
                padding: "40px 20px",
                textAlign: "center",
                margin: "0px 16px",
                borderRadius: "20px",
            },
            title: {
                fontSize: "24px",
            },
            label: {
                fontSize: "14px",
            },
            input: {
                padding: "10px",
                borderRadius: "10px",
                fontSize: "16px",
                backgroundColor: "#FFFFFF",
                width: "100%",
                marginTop: "2.5rem",
                boxSizing: "border-box",
            },
            button: {
                backgroundColor: "#5D5DFF",
                color: "white",
                border: "none",
                borderRadius: "10px",
                padding: "12px",
                fontSize: "16px",
                cursor: "pointer",
                width: "100%",
                transition: "background-color 0.3s",
            },
            buttonHover: {
                backgroundColor: "#4A4AE8",
            },
            error: {
                color: "red",
                textAlign: "center",
                marginBottom: "1rem",
            },
        };
    }

    return {
        container: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            minHeight: "100vh",
            boxSizing: "border-box",
        },
        form: {
            width: "100%",
            maxWidth: "400px",
            backgroundColor: "#F3F3FF",
            padding: "100px 80px",
            borderRadius: "20px",
        },
        title: {
            fontSize: "32px",
            color: "#090948",
            marginBottom: "8px",
            textAlign: "center",
        },
        label: {
            fontSize: "16px",
            color: "#090948",
            textAlign: "center",
        },
        input: {
            padding: "10px",
            borderRadius: "10px",
            fontSize: "16px",
            backgroundColor: "#FFFFFF",
            width: "100%",
            marginTop: "3rem",
            boxSizing: "border-box",
        },
        button: {
            backgroundColor: "#5D5DFF",
            color: "white",
            border: "none",
            borderRadius: "10px",
            padding: "12px",
            fontSize: "16px",
            cursor: "pointer",
            width: "100%",
            transition: "background-color 0.3s",
        },
        buttonHover: {
            backgroundColor: "#4A4AE8",
        },
        buttonDisabled: {
            cursor: "not-allowed",
            opacity: "0.6",
        },
        actions: {
            display: "flex",
            flexDirection: "column",
            gap: "10px",
        },
        error: {
            color: "red",
            textAlign: "center",
            marginBottom: "1rem",
        },
    };
};

export const statusFormStyles = (width) => {
    const baseStyles = {
        container: {
            boxSizing: "border-box",
            fontFamily: "Arial, sans-serif",
        },
        title: {
            color: "#333",
            textAlign: "center",
            fontSize: "28px",
            marginBottom: "20px",
            fontWeight: "bold",
        },
        actionButton: {
            padding: "10px 20px",
            borderRadius: "10px",
            border: "1px solid",
            cursor: "pointer",
            fontSize: "16px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "6px",
            backgroundColor: "transparent",
            transition: "all 0.3s ease",
        },
        unlockButton: {
            borderColor: "#4CAF50",
            color: "#4CAF50",
        },
        lockButton: {
            borderColor: "#f44336",
            color: "#f44336",
        },
        sectionContainer: {
            backgroundColor: "#F2F2F9",
            borderRadius: "10px",
            marginBottom: "10px",
            overflow: "hidden",
        },
        sectionHeader: {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "10px",
            cursor: "pointer",
            backgroundColor: "#D4D4F4",
        },
        sectionTitle: {
            margin: 0,
            fontSize: "16px",
            fontWeight: "semibold",
            color: "#333",
        },
        sectionContent: {
            padding: "10px",
        },
        checkboxContainer: {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "10px",
        },
        checkbox: {
            marginRight: "10px",
            width: "20px",
            height: "20px",
            accentColor: "#5D5DFF",
        },
        submitButton: {
            backgroundColor: "#5D5DFF",
            color: "white",
            border: "none",
            borderRadius: "12px",
            padding: "12px",
            fontSize: "18px",
            cursor: "pointer",
            width: "100%",
            transition: "background-color 0.3s ease",
        },
        submitButtonHover: {
            backgroundColor: "#4A4AE8",
        },
        submitButtonDisabled: {
            cursor: "not-allowed",
            opacity: "0.6",
        },
        textarea: {
            width: "95%",
            padding: "8px",
            border: "none",
            marginTop: "10px",
            resize: "vertical",
            minHeight: "60px",
            maxHeight: "200px",
            borderRadius: "5px",
        },
        // Inspection Accordion
        inspectionItem: {
            backgroundColor: "#F2F2F9",
            borderRadius: "8px",
            marginBottom: "8px",
            overflow: "hidden",
        },
        inspectionItemHeader: {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "12px",
            cursor: "pointer",
            backgroundColor: "#F2F2F9",
            color: "#333",
            fontWeight: "bold",
        },
        inspectionItemContent: {
            padding: "12px",
        },
        checkboxAndNotes: {
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            marginTop: "12px",
        },
        addNotesButton: {
            display: "flex",
            alignItems: "center",
            gap: "4px",
            backgroundColor: "#5D5DFF",
            borderRadius: "5px",
            border: "none",
            marginTop: "0.6rem",
            padding: "0.4rem",
            color: "#fff",
            cursor: "pointer",
            fontSize: "10px",
        },
        imageSection: {
            display: "flex",
            flexWrap: "wrap",
            gap: "8px",
        },
        imageContainer: {
            position: "relative",
            width: "80px",
            height: "80px",
        },
        imagePreviewContainer: {
            display: "flex",
            alignItems: "center",
            gap: "12px",
        },
        image: {
            width: "100%",
            height: "100%",
            objectFit: "cover",
            borderRadius: "10px",
        },
        deleteImageButton: {
            position: "absolute",
            top: "-8px",
            left: "-12px",
            backgroundColor: "transparent",
            border: "none",
            cursor: "pointer",
        },
        addImageButton: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "4px",
            width: "80px",
            height: "80px",
            backgroundColor: "#fff",
            border: "none",
            borderRadius: "10px",
            boxShadow: "0px 4.447px 8.894px 0px rgba(0, 0, 0, 0.08)",
            color: "#5D5DFF",
            cursor: "pointer",
            fontSize: "14px",
        },
    };

    if (width <= 768) {
        return {
            ...baseStyles,
            container: {
                ...baseStyles.container,
                width: "100%",
                height: "100vh",
                display: "flex",
                flexDirection: "column",
            },
            topButtons: {
                display: "flex",
                justifyContent: "space-between",
                padding: "16px",
                position: "fixed",
                top: 0,
                left: 0,
                right: 0,
                backgroundColor: "white",
                zIndex: 1000,
            },
            actionButton: {
                ...baseStyles.actionButton,
                width: "48%",
            },
            scrollableContent: {
                flex: 1,
                overflow: "auto",
                padding: "20px",
                marginTop: "60px",
                marginBottom: "60px",
            },
            bottomButton: {
                position: "fixed",
                bottom: 0,
                left: 0,
                right: 0,
                padding: "16px",
                backgroundColor: "white",
                zIndex: 1000,
            },
        };
    }

    return {
        ...baseStyles,
        container: {
            ...baseStyles.container,
            maxWidth: "800px",
            margin: "0 auto",
            padding: "40px 20px",
        },
        topButtons: {
            display: "flex",
            justifyContent: "space-between",
            marginBottom: "30px",
            gap: "8px",
        },
        actionButton: {
            ...baseStyles.actionButton,
            width: "200px",
        },
        scrollableContent: {
            marginBottom: "30px",
        },
        bottomButton: {
            marginTop: "30px",
        },
    };
};
